class AccessTokenStore {
  constructor() {
    if (!AccessTokenStore.instance) {
      this.accessToken = null;
      AccessTokenStore.instance = this;
    }
    return AccessTokenStore.instance;
  }

  setToken(accessToken) {
    this.accessToken = accessToken;
  }

  getToken() {
    Object.freeze(this.accessToken);
    return this.accessToken;
  }
}

const instance = new AccessTokenStore();

export default instance;


